export const EXCEPTION_LIST_REQUEST = 'EXCEPTION_LIST_REQUEST';
export const EXCEPTION_LIST_SUCCESS = 'EXCEPTION_LIST_SUCCESS';
export const EXCEPTION_LIST_FAIL = 'EXCEPTION_LIST_FAIL';


export const EXCEPTION_RESOLVE_STATUS_REQUEST = 'EXCEPTION_RESOLVE_STATUS_REQUEST';
export const EXCEPTION_RESOLVE_STATUS_SUCCESS = 'EXCEPTION_RESOLVE_STATUS_SUCCESS';
export const EXCEPTION_RESOLVE_STATUS_FAIL = 'EXCEPTION_RESOLVE_STATUS_FAIL';